module.exports = __webpack_public_path__ + "static/media/wechat-guide.e26dfd98.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/videoShare/components/images/wechat-guide.png
// module id = 1006
// module chunks = 0